import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { NotificationPreferenceMessages as messages } from './NotificationPreference.i18n';

export class NotifPref extends React.Component {
  render() {
    const notifPref = this.props.patientNotifPreference;
    const notifOptions = [];
    let notifPrefContent = null;
    if (notifPref) {
      if (typeof notifPref === 'object') {
        if (notifPref.email === 'True') {
          notifOptions.push('email');
        }
        if (notifPref.sms === 'True') {
          notifOptions.push('sms');
        }
      }

      if (notifOptions.length < 1) {
        notifPrefContent = <FormattedMessage { ...messages.notifPreference.Off } />;
      } else {
        notifPrefContent = (
          <span>
            <FormattedMessage { ...messages.notifPreference[notifOptions[0]] } />
            {
              notifOptions.length > 1 ?
              <span>
              &nbsp;<FormattedMessage { ...messages.notifPreference.and } />
              &nbsp;<FormattedMessage { ...messages.notifPreference[notifOptions[1]] } />
              </span> :
              ''
            }
          </span>
        );
      }
    }

    return notifPrefContent;
  }
}

NotifPref.propTypes = {
  patientNotifPreference: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string,
  ]),
  fieldName: PropTypes.object,
};
